// Module
var code = "<h2 class=\"interiorSectionHeading\"> View Loan Summary </h2> <p>Get an at-a-glance view of your Loan Summary or view individual loan details for more information about your loans.</p> ";
// Exports
export default code;